import styled from "styled-components/macro";
import { Typography } from "@mui/material";

export const BankTitle = styled(Typography)`
  text-align: center;
  margin-bottom: 20px;
`;
